import { SortOption, SortTypes } from '~shared/modules/application-event/models/sort-option.model';

export interface SortState {
  sortOption: SortOption;
}

export const sortInitialState: SortState = {
  sortOption: SortTypes[0],
};
